module.exports = __webpack_public_path__ + "img/box-gray.15fe72e3.png";